/**
 * Component re-exports.
 * These libraries have type conflicts or lack proper JSX constructor types.
 * Cast them as JSX element constructors to allow JSX usage.
 */

import React from 'react';
import {
  DragDropContext as DragDropContextBase,
  Droppable as DroppableBase,
  Draggable as DraggableBase,
  type DragDropContextProps,
  type DroppableProps,
  type DraggableProps,
  type DroppableProvided,
  type DroppableStateSnapshot,
  type DraggableProvided,
  type DraggableStateSnapshot,
  type DropResult,
  type ResponderProvided,
} from 'react-beautiful-dnd';
import { Collapse as CollapseBase } from 'react-collapse';
import * as CopyToClipboardNS from 'react-copy-to-clipboard';
import { EditText as EditTextBase } from 'react-edit-text';

// Cast as React JSX element constructors to work around type conflicts
export const DragDropContext = DragDropContextBase as unknown as React.JSXElementConstructor<DragDropContextProps>;
export const Droppable = DroppableBase as unknown as React.JSXElementConstructor<DroppableProps>;
export const Draggable = DraggableBase as unknown as React.JSXElementConstructor<DraggableProps>;

// Export types for use in components
export type { DragDropContextProps, DroppableProps, DraggableProps, DroppableProvided, DroppableStateSnapshot, DraggableProvided, DraggableStateSnapshot, DropResult, ResponderProvided };

// Libraries without proper types: cast as JSX constructors
export const Collapse = CollapseBase as unknown as React.JSXElementConstructor<any>;
export const CopyToClipboard = CopyToClipboardNS.default || (CopyToClipboardNS as any);
export const EditText = EditTextBase as unknown as React.JSXElementConstructor<any>;
